export const daysOfTheWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const ICON_BUTTON_WIDTH = 56;
export const TOP_BAR_HEIGHT = 72;
export const ICON_SIZE = 24;
